export default __webpack_public_path__ + "static/media/video.1b56ec7b.mp4";